// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dd-3";
export var flatBottomCorners = "_dd-5";
export var productImage = "_dd-0";
export var quantityContainer = "_dd-2";
export var quantityHeader = "_dd-6";
export var tooltip = "_dd-1";
export var wrapAndEllipsesOverflow = "_dd-4";